import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, switchMap, tap, timer } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    private count$ = new BehaviorSubject<number>(0);
    private lastCount = 0;
    private notificationAudio = new Audio('/audio/notification-audio.mp3');
    baseUrl = `${environment.apiUrl}/notification/v1/user-notification`;
    apiUrl = `${environment.apiUrl}/notification/v1/notification-announcement`;

    constructor(private http: HttpClient) {}

    /** 🔁 background polling trigger */
    startPolling(getPayload: () => any) {
        return timer(0, 60000).pipe(
            switchMap(() => this.http.get(`${this.apiUrl}/count`, getPayload())),
            tap((res: any) => this.playSoundIfNew(res?.notification_count))
        );
    }

    getAnnouncementCount(){
        return this.http.get(`${this.apiUrl}/count`);
    }

    countChanges() {
        return this.count$.asObservable();
    }

    setCount(val: number) {
        this.count$.next(val);
    }

    list(payload: any) {
        return this.http.post(`${this.baseUrl}/list`, payload);
    }

    read(payload: any) {
        return this.http.post(`${this.baseUrl}/read`, payload);
    }

    delete(payload: any) {
        return this.http.post(`${this.baseUrl}/delete`, payload);
    }

    private playSoundIfNew(nextCount: number | undefined) {
        if (typeof nextCount !== 'number') {
            return;
        }
        if (this.lastCount > 0 && nextCount > this.lastCount) {
            this.notificationAudio.currentTime = 0;
            this.notificationAudio.play().catch(() => {
                // Autoplay may be blocked until a user interaction happens.
            });
        }
        this.lastCount = nextCount;
    }
}
